import { cn } from "@/lib/utils"

export function CourseLayout({ children, className }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <section
      className={cn(
        "flex flex-col gap-8 py-8 pr-1 sm:gap-12 sm:py-12 sm:pr-2 [&_blockquote]:my-4 [&_h2]:mt-4 [&_h3]:mb-1 [&_p]:text-base sm:[&_p]:text-lg",
        className
      )}
    >
      {children}
    </section>
  )
}
